(() => {
  const btn = document.querySelector('[data-scroll-top]');
  if (!btn) return;

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const toggle = () => {
    // 400px aşağı inince gözüksün
    if (window.scrollY > 400) btn.classList.add('is-visible');
    else btn.classList.remove('is-visible');
  };

  window.addEventListener('scroll', toggle, { passive: true });
  toggle();

  btn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: prefersReduced.matches ? 'auto' : 'smooth'
    });
  });
})();
